var _path, _path2, _polygon, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _line, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _polyline10, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _polyline16, _polyline17, _polyline18, _polyline19, _polyline20, _polyline21, _polyline22, _polyline23, _polyline24, _polyline25, _polyline26, _polyline27, _polyline28, _path23, _path24, _polyline29, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotirinneGfx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    enableBackground: "new 0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006838",
    d: "M950.919,645.242c0,150.77-209.259,272.989-467.388,272.989c-258.134,0-467.393-122.22-467.393-272.989 c0-150.771,209.259-272.991,467.393-272.991C741.66,372.251,950.919,494.472,950.919,645.242z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AE5E5D",
    d: "M562.127,879.907"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A4AD1B",
    points: "711.031,433.196 711.031,657.699 189.866,620.473 189.866,386.957 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#8C9615",
    points: "711.027,657.699 711.027,395.97 745.494,153.081 822.705,247.066 822.705,508.795 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#BE1E2D",
    points: "754.865,142.631 196.385,106.663 146.032,390.804 714.311,437.562 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#93111D",
    points: "754.865,142.631 749.287,180.31 822.705,265.102 848.556,265.102 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 599.5586,
    y1: 443.7383,
    x2: 609.0772,
    y2: 534.3019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#121212"
    }
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#SVGID_1_)",
    points: "562.127,519.366 562.127,447.673 646.221,455.945 646.221,530.397 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.8188,
    y1: 422.125,
    x2: 313.3374,
    y2: 512.6877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#121212"
    }
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#SVGID_2_)",
    points: "266.388,497.753 266.388,426.06 350.481,434.333 350.481,508.784 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 793.835,
    y1: 311.8359,
    x2: 804.6846,
    y2: 415.0632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#121212"
    }
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#SVGID_3_)",
    points: "786.852,416.938 786.852,342.66 811.669,309.962 811.669,384.475 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 749.4414,
    y1: 220.5,
    x2: 760.291,
    y2: 323.7263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#121212"
    }
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#SVGID_4_)",
    points: "742.457,325.601 742.457,251.323 767.274,218.625 767.274,293.138 "
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#848E13",
    points: "491.549,679.928 553.346,609.891 551.152,425.154 491.804,511.381 "
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#6D2F4B",
    points: "535.924,577.37 535.924,469.505 505.589,507.781 505.589,615.65 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#A31724",
    x1: 513.861,
    y1: 632.195,
    x2: 491.804,
    y2: 632.195
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 601.5615,
    y1: 567.3398,
    x2: 562.5748,
    y2: 635.9994,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M611.1,594.965c-3.26,24.413-22.77,41.956-43.576,39.169c-20.807-2.791-35.028-24.825-31.761-49.251 c3.272-24.426,22.777-41.96,43.588-39.177C600.148,548.489,614.371,570.543,611.1,594.965z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 619.8828,
    y1: 586.002,
    x2: 590.2604,
    y2: 638.1699,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M616.682,609.441c-2.484,18.557-17.309,31.887-33.114,29.773 c-15.81-2.12-26.606-18.871-24.122-37.432c2.476-18.549,17.304-31.878,33.109-29.758 C608.36,574.135,619.162,590.894,616.682,609.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 671.5488,
    y1: 567.8564,
    x2: 632.1797,
    y2: 637.1894,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M661.182,602.781c-3.304,24.651-23.003,42.371-44.016,39.557 c-21.012-2.808-35.359-25.08-32.06-49.736c3.296-24.655,22.995-42.359,44.004-39.557 C650.119,555.856,664.475,578.117,661.182,602.781z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 687.0684,
    y1: 586.5254,
    x2: 658.0202,
    y2: 637.6821,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M664.316,615.84c-2.432,18.193-16.969,31.26-32.472,29.184 c-15.503-2.072-26.089-18.504-23.662-36.688c2.437-18.197,16.974-31.269,32.476-29.2 C656.161,581.215,666.752,597.646,664.316,615.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 723.7734,
    y1: 585.4951,
    x2: 694.7268,
    y2: 636.649,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M690.717,618.005c-2.432,18.197-16.973,31.256-32.471,29.188 c-15.508-2.072-26.094-18.512-23.658-36.696c2.428-18.193,16.965-31.26,32.463-29.2 C682.554,583.38,693.145,599.812,690.717,618.005z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 635.7051,
    y1: 580.7842,
    x2: 596.7187,
    y2: 649.4431,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M633.158,615.646c-3.26,24.413-22.77,41.955-43.576,39.168 c-20.807-2.791-35.028-24.825-31.761-49.25c3.271-24.426,22.777-41.961,43.588-39.178 C622.207,569.17,636.43,591.225,633.158,615.646z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 654.0273,
    y1: 599.4473,
    x2: 624.4052,
    y2: 651.6147,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M638.74,630.123c-2.484,18.556-17.309,31.886-33.114,29.773 c-15.81-2.121-26.606-18.872-24.122-37.433c2.476-18.548,17.304-31.878,33.109-29.757 C630.419,594.815,641.221,611.574,638.74,630.123z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 705.6914,
    y1: 581.3008,
    x2: 666.3224,
    y2: 650.6335,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M683.24,623.462c-3.304,24.651-23.003,42.372-44.016,39.557 c-21.012-2.808-35.359-25.08-32.06-49.735c3.296-24.656,22.995-42.36,44.004-39.557 C672.177,576.538,686.533,598.798,683.24,623.462z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 721.2109,
    y1: 599.9707,
    x2: 692.1625,
    y2: 651.1278,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M686.375,636.521c-2.432,18.193-16.969,31.261-32.472,29.185 c-15.503-2.072-26.09-18.504-23.662-36.689c2.436-18.196,16.974-31.268,32.476-29.199 C678.22,601.896,688.811,618.328,686.375,636.521z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 757.918,
    y1: 598.9404,
    x2: 728.8712,
    y2: 650.0946,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M712.775,638.686c-2.432,18.197-16.973,31.256-32.471,29.188 c-15.508-2.072-26.094-18.513-23.658-36.697c2.428-18.192,16.965-31.26,32.463-29.2 C704.612,604.062,715.203,620.493,712.775,638.686z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.3086,
    y1: 604.0322,
    x2: 50.3222,
    y2: 672.6911,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M238.838,593.588c-3.26,24.413-22.77,41.955-43.576,39.168 c-20.806-2.791-35.028-24.825-31.761-49.25c3.272-24.426,22.777-41.96,43.588-39.178 C227.888,547.111,242.11,569.166,238.838,593.588z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.6304,
    y1: 622.6953,
    x2: 78.0079,
    y2: 674.8634,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M244.42,608.064c-2.484,18.557-17.309,31.886-33.114,29.773 c-15.81-2.121-26.606-18.871-24.123-37.432c2.476-18.549,17.305-31.879,33.11-29.758C236.1,572.757,246.9,589.516,244.42,608.064z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.2949,
    y1: 604.5488,
    x2: 119.9258,
    y2: 673.8818,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M288.921,601.403c-3.304,24.651-23.004,42.372-44.016,39.557 c-21.012-2.808-35.36-25.08-32.06-49.735c3.296-24.656,22.996-42.359,44.004-39.557 C277.857,554.479,292.213,576.74,288.921,601.403z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.8145,
    y1: 623.2188,
    x2: 145.7663,
    y2: 674.3755,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M292.056,614.463c-2.432,18.192-16.969,31.26-32.472,29.184 c-15.502-2.072-26.089-18.504-23.662-36.689c2.436-18.196,16.973-31.268,32.476-29.199 C283.9,579.838,294.491,596.27,292.056,614.463z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.52,
    y1: 622.1875,
    x2: 182.4729,
    y2: 673.3423,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M318.456,616.628c-2.432,18.196-16.973,31.256-32.472,29.188 c-15.507-2.072-26.094-18.512-23.658-36.697c2.428-18.192,16.965-31.26,32.464-29.199 C310.293,582.003,320.884,598.435,318.456,616.628z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.7788,
    y1: 604.7227,
    x2: 69.7923,
    y2: 673.3818,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M252.626,596.342c-3.26,24.414-22.77,41.956-43.576,39.169 c-20.806-2.791-35.028-24.825-31.761-49.251c3.272-24.425,22.777-41.959,43.588-39.176 C241.676,549.866,255.898,571.921,252.626,596.342z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.1016,
    y1: 623.3857,
    x2: 97.4792,
    y2: 675.5536,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M258.208,610.819c-2.484,18.556-17.308,31.886-33.114,29.773 c-15.81-2.121-26.606-18.872-24.123-37.433c2.476-18.548,17.304-31.877,33.11-29.757 C249.888,575.512,260.688,592.271,258.208,610.819z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.7656,
    y1: 605.2402,
    x2: 139.3964,
    y2: 674.5734,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M302.709,604.158c-3.304,24.651-23.004,42.372-44.016,39.557 c-21.012-2.808-35.36-25.08-32.06-49.735c3.296-24.656,22.996-42.36,44.004-39.557 C291.646,557.234,306.001,579.494,302.709,604.158z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.2852,
    y1: 623.9102,
    x2: 165.2368,
    y2: 675.0671,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M305.843,617.217c-2.432,18.193-16.969,31.261-32.472,29.185 c-15.502-2.072-26.089-18.504-23.662-36.689c2.436-18.196,16.973-31.268,32.476-29.199 C297.688,582.593,308.279,599.024,305.843,617.217z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.9917,
    y1: 622.8789,
    x2: 201.945,
    y2: 674.0331,
    gradientTransform: "matrix(0.7143 0.0955 -0.1733 1.2957 261.9314 -245.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#339947"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#001F00"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M332.244,619.383c-2.432,18.196-16.973,31.256-32.472,29.188 c-15.507-2.072-26.094-18.512-23.658-36.697c2.428-18.192,16.965-31.26,32.464-29.199 C324.081,584.758,334.672,601.189,332.244,619.383z"
  }))), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#6F7073",
    points: "560.229,634.78 590.818,593.672 602.969,595.74 576.6,636.586 "
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#6F7073",
    points: "576.083,644.26 603.312,602.381 618.648,606.178 591.938,646.587 "
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#404041",
    points: "560.746,629.263 560.92,634.78 590.907,593.762 590.907,588.765 "
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#404041",
    points: "576.604,643.913 576.43,636.675 602.973,595.655 602.973,602.725 "
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#404041",
    points: "592.801,655.809 592.288,645.98 618.83,604.962 618.83,612.031 "
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#404041",
    points: "504.163,622.352 561.55,629.492 561.234,634.304 576.6,636.586 576.858,644.082 592.628,646.15  593.145,654.682 608.914,657.783 608.914,664.764 624.166,667.607 624.166,673.812 640.953,675.754 640.695,682.411  656.739,683.894 656.613,688.394 504.329,669.663 "
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#6F7073",
    points: "503.44,622.626 535.496,582.814 590.56,589.02 561.089,629.605 "
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#6F7073",
    points: "593.145,654.682 618.822,612.031 635.197,617.375 608.655,658.042 "
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#6F7073",
    points: "608.999,664.598 634.85,624.096 650.361,626.508 623.823,667.87 "
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#6F7073",
    points: "624.166,674.328 650.361,633.229 666.389,635.297 640.97,676.138 "
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#6F7073",
    points: "640.194,682.343 665.872,642.192 680.005,643.399 656.998,684.152 "
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#404041",
    points: "608.833,665.284 608.66,658.046 635.201,617.027 635.201,624.096 "
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#404041",
    points: "624.001,674.591 623.827,667.353 650.369,626.334 650.369,633.402 "
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#404041",
    points: "640.028,683.55 639.854,676.312 666.396,635.293 666.396,642.361 "
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#404041",
    points: "655.883,688.895 655.709,681.656 679.662,643.399 680.005,651.498 "
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#D6DE23",
    points: "491.808,508.853 491.808,679.669 313.95,658.042 313.95,484.898 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.8818,
    y1: 508.9219,
    x2: 447.666,
    y2: 582.9836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#121212"
    }
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#SVGID_25_)",
    points: "408.559,572.152 408.559,512.214 478.865,518.576 478.865,579.705 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.3296,
    y1: 500.4043,
    x2: 366.1139,
    y2: 574.467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#121212"
    }
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#SVGID_26_)",
    points: "327.059,563.629 327.059,503.69 397.365,511.053 397.365,571.182 "
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#A31724",
    points: "562.127,420.787 312.078,401.119 280.86,486.967 520.757,512.214 "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M663.662,642.58l-0.501-0.429c-0.706-0.432-70.97-43.434-79.032-50.155 c-8.511-7.093-18.27-9.933-18.992-10.114l-60.666-7.578l-0.509,4.104l7.149,0.889v43.938h4.136v-43.422l37.227,4.633v42.926h4.136 v-42.408l7.703,0.957c0.093,0.028,9.322,2.71,17.167,9.25c2.108,1.757,8.123,5.788,15.938,10.829h-0.824v46.876h4.137v-44.747 c10.963,7.024,24.591,15.531,36.147,22.688h-0.303v44.121h4.136v-41.746c10.207,6.31,18.148,11.177,19.986,12.3 c0.771,1.014,1.838,2.961,1.41,3.89c-0.319,0.69-1.943,1.426-5.538,1.426v4.137c5.058,0,8.099-1.253,9.29-3.821 C667.588,647.387,664.07,643.061,663.662,642.58z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B1B3B5",
    d: "M1008.147,759.73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.4126,
    y1: 571.1797,
    x2: 240.7666,
    y2: 571.1797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    style: {
      stopColor: "#BBBDBF"
    }
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#SVGID_27_)",
    points: "240.767,857.922 231.949,286.106 213.413,284.438 220.726,849.892 "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 222.4365,
    cy: 281.647,
    r: 15.8179,
    gradientTransform: "matrix(1 0 0 0.8 0 56.3294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#515254"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_28_)",
    cx: 222.436,
    cy: 281.646,
    rx: 18.613,
    ry: 12.409
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotirinneGfx);
export default __webpack_public_path__ + "static/media/kotirinne-gfx.e0ee9c648c90dd57c029bef9aaa328b9.svg";
export { ForwardRef as ReactComponent };